<template>
  <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
    <vx-card no-shadow class="custom-min-height">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="mb-base">
            <h6 class="mb-4">ปิดปรับปรับปรุงระบบ (ชั่วคราว)</h6>
            <div class="flex items-center mb-4">
              <vs-switch v-model="form.qrPayment.status" />
              <span class="ml-4">ปิดปรับปรุงระบบดาวโหลด QR CODE</span>
            </div>
            <div class="flex items-center mb-4">
              <vs-switch v-model="form.payment.status" />
              <span class="ml-4">ปิดปรับปรุงระบบการชำระเงิน</span>
            </div>
          </div>
          <div class="mb-base">
            <h6 class="mb-4">ตั้งเวลาปิดปรับปรับปรุงระบบ</h6>
            <div class="items-center mb-4">
              <div class="row mb-2">
                <div class="col">
                  <span class="md-full">ปิดปรับปรุงระบบดาวโหลด QR CODE</span>
                  <div class="md-full flex">
                    <vs-input class="felx-1 mr-2" placeholder="Placeholder" v-model="form.qrPayment.start" />
                    <vs-input class="felx-1" placeholder="Disabled" v-model="form.qrPayment.end" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="md-full">ปิดปรับปรุงระบบชำระเงิน</span>
                  <div class="md-full flex">
                    <vs-input class="felx-1 mr-2" placeholder="Placeholder" v-model="form.payment.start" />
                    <vs-input class="felx-1" placeholder="Disabled" v-model="form.payment.end" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-base">
            <h6 class="mb-4">ตั้งค่าระบบ</h6>
            <div class="vx-row flex flex-wrap mb-4">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
                <validation-provider @name="model.name" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">{{ model.name }}* <a class="cursor-pointer" @click="model.active = true"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                  <vs-textarea  v-model="form2.otpEmail" rows="3"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-base">
            <vs-button class="ml-auto mt-2" @click="summit()">บันทึก</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">คืนค่า</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <vs-popup
      :active.sync="model.active"
      :title="model.name"
      class="custom-popup"
    >
      <div class="popup-content">
        <span v-html="model.description"></span>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {IMaintenanceSystem, IStatus} from "@/constants/interface";
import {createNamespacedHelpers} from "vuex";
import {ValidationProvider} from "vee-validate";
const { mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  components: {
    ValidationProvider,
  },
  data() {
    return {
      model: {
        active: false,
        name: '',
        description: '',
      },
      form: {
        qrPayment: {
          id: "",
          status: true,
          start: "05.00",
          end: "22.45"
        },
        payment: {
          id: "",
          status: true,
          start: "05.00",
          end: "22.45"
        },
      },
      form2: {
        otpEmail: '',
      },
    };
  },
  computed: {
    ...mapSystemState(['status', 'maintenances', 'config']),
  },
  methods: {
    ...mapSystemActions([
      'initializing',
      'getMaintenances',
      'updateMaintenances',
      'getConfig',
      'updateConfig',
    ]),
    async summit () {
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          alert('กรุณากรอกข้อมูลให้ครบถ้วน')
          return
        }
        const {updateMaintenances, updateConfig} = vm
        await updateConfig({
          form: {
            otpEmail: vm.form2.otpEmail,
          },
          vm,
          notify: false,
        })

        await updateMaintenances({
          form: [
            {
              id: vm.form.qrPayment.id,
              maintenanceSystem: IMaintenanceSystem.qrPayment,
              start: vm.form.qrPayment.start,
              end: vm.form.qrPayment.end,
              status: (vm.form.qrPayment.status ? IStatus.disabled : IStatus.enabled)
            },
            {
              id: vm.form.payment.id,
              maintenanceSystem: IMaintenanceSystem.payment,
              start: vm.form.payment.start,
              end: vm.form.payment.end,
              status: (vm.form.payment.status ? IStatus.disabled : IStatus.enabled)
            }
          ]
        })
      })
    },
    async initDate() {
      const vm = this;
      const { getMaintenances, getConfig } = vm
      // set form data
      await getMaintenances();
      const qrPayment = vm.maintenances.find(res => res.maintenanceSystem === IMaintenanceSystem.qrPayment)
      const payment = vm.maintenances.find(res => res.maintenanceSystem === IMaintenanceSystem.payment)
      vm.form.qrPayment = {
        id: qrPayment.id,
        status: qrPayment.status === IStatus.disabled,
        start: qrPayment.start,
        end: qrPayment.end,
      }
      vm.form.payment = {
        id: payment.id,
        status: payment.status === IStatus.disabled,
        start: payment.start,
        end: payment.end,
      }

      await getConfig();
      vm.form2 = {
        otpEmail: vm.config.otpEmail,
      }

      // set model data
      vm.model = {
        active: false,
        name: 'OTP Email',
        description: 'ระบบจะส่งรหัส OTP ไปยังอีเมล์ของผู้ใช้งานที่ลงทะเบียนไว้ โดยจะใช้ในการยืนยันการใช้งานของผู้ใช้งาน โดยหากต้องการกำหนดมากกว่า 1 รายการ กรุณาใส่อีเมล์ที่ต้องการแยกด้วยเครื่องหมาย , (เครื่องหมายคอมม่า) ตัวอย่างเช่น a@a.com, b@b.com',
      }
    }
  },
  async created () {
    await this.initDate()
  },
};
</script>

<style scoped>
.custom-min-height {
  min-height: 500px; /* Set your desired minimum height */
}
.position-bottom-right {
  align-self: flex-end;
  margin: 16px; /* Adjust the margin as needed */
}
</style>
